export default __webpack_public_path__ + "715243f3b38d34a4370d24034736cd2f.svg";